<template>
  <div
    class="modal set-integrations-add-panel set-integrations-add-panel-values1 right-sliding-panel right-sliding-panel-xs"
    :class="[
      { 'show d-block': show },
      { 'd-none': !show },
      { 'modal-mini': type === 'mini' },
    ]"
    v-show="show"
    tabindex="-1"
    role="dialog"
    :aria-hidden="!show"
  >
    <div class="modal-dialog mb-0">
      <div class="modal-content">
        <modal-topbar>
          <template v-if="!currentIntegrationId">
            <a slot="left" @click="closePanel">
              <i class="fas fa-chevron-left mr-1"></i>
              <span>Settings</span>
            </a>
            <div slot="center">Add new integration</div>
          </template>
          <template v-else>
            <a slot="left" @click="closePanel()">
              <i class="fas fa-chevron-left mr-1"></i>
              <span>Back</span>
            </a>
            <div slot="center">
              {{ availableIntegrations[currentIntegrationId].name }}
            </div>
          </template>
        </modal-topbar>

        <div v-if="currentIntegrationId" class="modal-body">
          <div class="d-flex align-items-baseline mt-5">
            <div class="card-icon">
              <img :src="availableIntegrations[currentIntegrationId].image" />
            </div>
            <h2
              class="ml-3"
              :id="availableIntegrations[currentIntegrationId].id"
            >
              {{ availableIntegrations[currentIntegrationId].name }}
            </h2>
          </div>

          <p
            class="mt-3"
            v-if="availableIntegrations[currentIntegrationId].input_label"
          >
            {{ availableIntegrations[currentIntegrationId].input_label }}
          </p>
          <p v-else class="mt-3">
            Insert the full URL of your
            {{ availableIntegrations[currentIntegrationId].name }} site. You
            will be redirected there: if the page does not exist double-check
            the URL you have provided.
          </p>
          <ul class="panel-blocks">
            <li class="panel-item mt-3">
              <div class="mb-2 setting-label">
                <span class=" nav-link-text">
                  Site URL
                </span>
              </div>
              <base-input
                :id="'integration_url_input_' + currentIntegrationId"
                class="input-group-alternative mb-4"
                :valid="!urlHasError"
                v-on:keydown="urlHasError = false"
                v-model="currentUrl"
                v-on:keyup.enter="connect()"
                type="text"
              >
                <div slot="addonLeft">
                  {{ currentProtocol }}
                </div>
                <div
                  v-if="
                    availableIntegrations[currentIntegrationId].domains.length
                  "
                  class="p-0"
                  slot="addonRight"
                >
                  <base-dropdown
                    v-if="
                      availableIntegrations[currentIntegrationId].domains
                        .length > 1
                    "
                    class="m-1"
                    position="right"
                  >
                    <a
                      slot="title"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      class="px-1 py-2"
                    >
                      .{{ currentDomain }}
                      <i class="fas fa-chevron-down"></i>
                    </a>
                    <template
                      v-for="(domain, index) in availableIntegrations[
                        currentIntegrationId
                      ].domains"
                    >
                      <a
                        :key="index"
                        @click="currentDomain = domain"
                        class="dropdown-item px-3 py-1"
                      >
                        .{{ domain }}
                        <i
                          v-show="domain === currentDomain"
                          class="fas fa-check mr-0 ml-2"
                        ></i>
                      </a>
                    </template>
                  </base-dropdown>
                  <div v-else class="px-2">.{{ currentDomain }}</div>
                </div>
              </base-input>
            </li>
          </ul>
          <div class="flex-center my-4">
            <base-button
              v-if="!currentIntegrationId"
              type="primary"
              class="btn-w-25"
              v-on:click="closePanel"
            >
              Close
            </base-button>
            <base-button
              v-else
              type="primary"
              class="btn-w-25"
              :disabled="loading.connect || loading.request"
              @click="connect()"
            >
              Connect
            </base-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* the user inputs some values (Magento, ...) */

import { AVAILABLE_INTEGRATIONS, MESSAGES } from "@/constants";
import { mapState } from "vuex";
// import configs from "../configs";

export default {
  name: "set-integrations-add-panel-values1",
  components: {},
  props: {
    currenciesList: {
      type: Array,
    },
    show: Boolean,
    type: {
      type: String,
      default: "",
      validator(value) {
        let acceptedValues = ["", "notice", "mini"];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: 'Modal type (notice|mini|"") ',
    },
    selectedIntegrationId: {
      type: String,
    },
    animationDuration: {
      type: Number,
      default: 500,
      description: "Modal transition duration",
    },
  },
  data() {
    return {
      availableIntegrations: AVAILABLE_INTEGRATIONS,
      loading: {
        request: false,
        connect: false,
      },
      currentIntegrationId: null,
      currentUrl: "",
      currentProtocol: "",
      currentDomain: "",
      urlHasError: false,
      localError: false,
    };
  },
  computed: {
    ...mapState({
      authUser: (state) => state.user.authUser,
      showAlert: (state) => state.alert.showAlert,
    }),
  },
  methods: {
    closePanel() {
      /* slide out panel */
      document.querySelector(
        ".set-integrations-add-panel-values1 .modal-dialog"
      ).style.right = `-100%`;
      /* reset panel */
      setTimeout(() => {
        this.$emit("update:show", false);
        this.$emit("close");
      }, this.animationDuration / 2);
    },
    selectIntegration(id) {
      this.currentIntegrationId = id;
      setTimeout(() => {
        document.getElementById("integration_url_input_" + id).focus();
      }, 200);
    },
    redirectToSite() {
      // TODO: add some redirect urls
    },
    async connect() {
      if (!this.currentUrl.trim()) {
        this.urlHasError = true;
        return;
      }

      this.currentDomain = this.currentDomain.trim();
      this.loading.request = true;

      try {
        // TODO: add some redirect urls
      } catch (error) {
        this.loading.request = false;
        if (!this.showAlert) {
          /* need to upate the message text */
          if (error.response.status === 422) {
            this.$store.dispatch("setAlert", {
              showAlert: true,
              content: error.response.statusText,
              alertClass: "danger",
            });
          } else {
            this.$store.dispatch("setAlert", {
              showAlert: true,
              content: MESSAGES["common-500"],
              alertClass: "danger",
            });
          }
        }
      }
    },
  },
  watch: {
    show(val) {
      const documentClasses = document.body.classList;
      if (val) {
        this.localError = false;
        this.currentIntegrationId = this.selectedIntegrationId;
        this.currentUrl = "";
        this.currentProtocol = "https://";
        if (this.currentIntegrationId) {
          this.currentDomain = AVAILABLE_INTEGRATIONS[this.currentIntegrationId]
            .domains.length
            ? AVAILABLE_INTEGRATIONS[this.currentIntegrationId].domains[0]
            : "";
        }
        this.loading.request = false;
        this.loading.connect = false;
        this.urlHasError = false;

        /* slide in panel*/
        documentClasses.add("modal-open");
        setTimeout(() => {
          document.querySelector(
            ".set-integrations-add-panel-values1 .modal-dialog"
          ).style.right = `0px`;
        }, 0);
      } else {
        /* reset panel */
        documentClasses.remove("modal-open");
        document.querySelector(".set-integrations-add-panel-values1").scrollTop = 0;
      }
    },
    currentUrl() {
      this.urlHasError = false;
      this.loading.connect = false;
      this.loading.request = false;
      if (this.currentDomain) {
        this.currentUrl = this.currentUrl
          .replace(/(^\w+:|^)\/\//, "")
          .replace(new RegExp(`.${this.currentDomain}$`, "g"), "");
      }
    },
  },
};
</script>
<style>
.modal.show {
  background-color: rgba(255, 255, 255, 0.7);
}
</style>
